import AbstractResolvableModel from './AbstractResolvableModel';
export function getPrivateKey(key) {
    return '_resolvable_' + key;
}
export function getPrivateTriggerKey(key) {
    return '_resolvable_trigger_' + key;
}
export function getModelClassResolvableCollection(modelClass, models = []) {
    let colClass;
    let c = modelClass;
    while (!colClass && c.prototype instanceof AbstractResolvableModel) {
        if (typeof c.getResolvableCollection === 'function') {
            colClass = c.getResolvableCollection();
            return new colClass(modelClass, models);
        }
        c = Object.getPrototypeOf(c);
    }
    throw new Error(`${modelClass.name} does not provide a ResolvableCollection`);
}
export function getConstructorOf(obj) {
    const proto = Object.getPrototypeOf(obj);
    if (!proto) {
        throw new Error(`${typeof obj} does not have a prototype`);
    }
    return proto.constructor;
}
//# sourceMappingURL=Utils.js.map